import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { APIListWrapper } from '../../models/common/api-list-wrapper.model';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import { ShipmentBulkImportBatch, ShipmentBulkImportPreview, ShipmentBulkImportProcessResult, ShipmentBulkImportRow } from './shipment-bulk-upload.model';

@Injectable({ providedIn: 'root' })
export class ShipmentBulkUploadService {
  private baseUrl = `${environment.restApiUrl}shipment-bulk-import-endpoint`;

  constructor(private http: HttpClient) {}

  upload(file: File, owningCompanyId: number): Observable<APIResponseWrapper<ShipmentBulkImportPreview>> {
    const form = new FormData();
    form.append('file', file);
    form.append('owningCompanyId', String(owningCompanyId));
    return this.http.post<APIResponseWrapper<ShipmentBulkImportPreview>>(`${this.baseUrl}/batches/upload`, form);
  }

  batches(owningCompanyId: number): Observable<APIListWrapper<ShipmentBulkImportBatch>> {
    return this.http.get<APIListWrapper<ShipmentBulkImportBatch>>(`${this.baseUrl}/batches`, {
      params: { owningCompanyId: String(owningCompanyId) }
    });
  }

  batch(batchId: number): Observable<APIResponseWrapper<ShipmentBulkImportPreview>> {
    return this.http.get<APIResponseWrapper<ShipmentBulkImportPreview>>(`${this.baseUrl}/batches/${batchId}`);
  }

  updateRow(row: ShipmentBulkImportRow): Observable<APIResponseWrapper<ShipmentBulkImportRow>> {
    return this.http.put<APIResponseWrapper<ShipmentBulkImportRow>>(`${this.baseUrl}/rows/${row.rowId}`, {
      values: row.values || {}
    });
  }

  processBatch(batchId: number): Observable<APIResponseWrapper<ShipmentBulkImportProcessResult>> {
    return this.http.post<APIResponseWrapper<ShipmentBulkImportProcessResult>>(`${this.baseUrl}/batches/${batchId}/process`, {});
  }

  processRow(rowId: number): Observable<APIResponseWrapper<ShipmentBulkImportRow>> {
    return this.http.post<APIResponseWrapper<ShipmentBulkImportRow>>(`${this.baseUrl}/rows/${rowId}/process`, {});
  }

  template(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/template`, { observe: 'response', responseType: 'blob' });
  }
}
